import React, { useEffect, useState } from "react";
import zoomSdk from "@zoom/appssdk";
import LogManager from "../utils/LogManager";
import Button from "@amzn/awsui-components-console/button";
import "./Login.css";
import aimsLogo from "../../images/aims_logo.svg";

const clientIDMap = new Map([
  ["tlxudevaimsui", "tlxuzoomtest"],
  ["sharedevaimsui", "ZoomAiMSBeta"],
  ["ztongdevaimsui", "ZoomAiMSBeta"],
  ["ziyudevaimsui", "ZoomAiMSBeta"],
  ["mznwngdevaimsui", "ZoomAiMSBeta"],
  ["aldaodevaimsui", "ZoomAiMSBeta"],
  ["beta", "ZoomAiMSBeta"],
  ["pdxprod", "ZoomAiMSProd"],
]);

const idpMap = new Map([
  ["test", "https://idp-integ.federate.amazon.com"],
  ["beta", "https://idp-integ.federate.amazon.com"],
  ["pdxprod", "https://idp.federate.amazon.com"],
]);

const generateRandomString = (length = 10) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const Login = () => {
  console.log("In login page");
  /**
   * Initialize Zoom SDK
   */
  const initializeZoomSdk = async () => {
    if (window.location.href === "http://localhost:3000/") {
      console.log("[Localhost] Skipping zoomSdk.config() in localhost");
      return;
    }
    try {
      const configResponse = await zoomSdk.config({
        popoutSize: { width: 320, height: 760 },
        capabilities: ["getRunningContext", "getUserContext", "getMeetingContext", "openUrl"],
      });
      console.log("Zoom SDK Configured Successfully:", configResponse);
      LogManager.info("Zoom SDK Configured Successfully:", configResponse);

      const runningContext = await zoomSdk.getRunningContext();
      console.log("The runningContext is:", runningContext);
      LogManager.info("The runningContext is:", runningContext);
    } catch (error) {
      console.error("Error fetching context or call APIs:", error);
      LogManager.error("Error fetching context or call APIs:", error);
    }
  };

  useEffect(() => {
    initializeZoomSdk();
  }, []);

  const handleLogin = async () => {
    let fullHost = window.location.hostname;
    console.log("[Login] FullHost is:", fullHost);

    const runningContext = await zoomSdk.getRunningContext();
    console.log("[Login] RunningContext is:", runningContext);

    let statePrefix = "";
    if (runningContext.context === "inMeeting") {
      statePrefix = "meeting";
    } else if (runningContext.context === "inMainClient") {
      statePrefix = "mainclient";
    }

    const state = statePrefix + generateRandomString(64);
    const nonce = generateRandomString(64);

    document.cookie = `aims_state=${state}; path=/; Secure; SameSite=Strict; Max-Age=43200; Domain=${fullHost}`;
    //Nonce is the RFP token here
    document.cookie = `aims_rfp=${nonce}; path=/; Secure; SameSite=Strict; Max-Age=43200; Domain=${fullHost}`;
    console.log(document.cookie);

    const envKey = fullHost.split(".")[1];
    console.log(envKey);
    let clientID;
    if (envKey === "test") {
      // for dev stack, full host is {alias}devaimsui.test.aims.meetex.enterprise-engineering.aws.dev
      const devEnvKey = fullHost.split(".")[0];
      console.log("devEnvKey is: " + devEnvKey);
      clientID = clientIDMap.get(devEnvKey);
    } else {
      clientID = clientIDMap.get(envKey);
    }
    console.log("ClientID is:" + clientID);
    const idp = idpMap.get(envKey);
    console.log(idp);

    const redirectUrl = `${idp}/api/oauth2/v1/authorize?client_id=${clientID}&redirect_uri=https://${fullHost}/login-redirect&response_type=code&scope=openid&state=${state}&nonce=${nonce}`;

    console.log("Open the redirect URL: " + redirectUrl);
    try {
      await zoomSdk.openUrl({
        url: redirectUrl,
      });
    } catch (error) {
      console.error("Failed to open URL in Zoom:", error);
      LogManager.error("Failed to open URL in Zoom:", error);
    }
  };

  return (
    <div data-login-container>
      <img src={aimsLogo} alt="AIMS Logo" data-login-logo />
      <h2 data-login-title>Log in with Amazon Federate</h2>
      <div style={{ width: "230px" }}>
        <Button variant="normal" fullWidth="true" onClick={handleLogin}>
          <span>Log in</span>
        </Button>
      </div>
    </div>
  );
};

export default Login;
